<template>
  <RightInfoPanelGeneric
    :value="value"
    :title-key="'stock_management.orders.title_info_date'"
    :items="items"
    :saving="saving"
    @save="$emit('save')"
    @back="$emit('back')"
  />
</template>

<script>
import RightInfoPanelGeneric from "@/components/Common/RightInfoPanelGeneric.vue";
import { ORDER_TYPE } from "@/pages/stock-management/orders/config/orderTypes";

export default {
  name: "OrdersRightPanel",
  components: {
    RightInfoPanelGeneric,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    items() {
      return [
        {
          labelKey: "stock_management.orders.order_type",
          path: "order_type",
          required: true,
        },
        {
          labelKey: "stock_management.orders.date",
          path: "date",
          required: true,
        },
        {
          labelKey: "common.legal_entity_name",
          path: "legal_entity_name",
          required: true,
        },
        {
          labelKey: "common.partner",
          path: "partner_name",
          required: Number(this.value?.order_type_id) !== ORDER_TYPE.INTERNAL,
        },
        {
          labelKey: "stock_management.orders.order_number",
          path: "order_number",
          required: true,
        },
        {
          labelKey: "common.product",
          path: "products",
          required: true,
          formatter: (val) => {
            const count = Array.isArray(val) ? val.length : 0;
            if (!count) return "*";
            return "" + count + (count === 1 ? " produs selectat" : " produse selectate");
          },
        },
      ];
    },
  },
};
</script>
